define('constants/liveReceptionistScriptWarmTransferCallerIdConstants',[], function() {
    return {
        Unknown: "0",
        CustomerServiceNumber: "1",
        CallersNumber: "2",
        HostedNumber: "3",
    };
});
